module.exports = __webpack_public_path__ + "static/img/kjdy02.7b73dde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/kjdy02.jpg
// module id = 1415
// module chunks = 0